<template>
    <v-dialog
        v-model="dialog"
        max-width="500"
        persistent
        scrollable
    >
        <v-card>
            <v-toolbar flat height="40" dark color="purple">
                <v-toolbar-title>
                    Déplacer {{ documentStore.fichier.name }}
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <SectionTreeview
                        v-model="destinationId"
                        use-local-cache
                    />
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn
                    depressed
                    color="teal"
                    small
                    outlined
                    @click="close"
                >
                    {{ $t('common.close') }}
                    <v-icon right>mdi-close</v-icon>
                </v-btn>
                <v-btn
                    depressed
                    color="purple"
                    class="white--text"
                    small
                    :loading="loading"
                    @click="move"
                >
                    Déplacer
                    <v-icon right>mdi-folder-move</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import useSharedData from "@/use/SharedData";
import {useDocumentStore} from "@/stores/Edms/Document";
import SectionTreeview from "@/views/Edms/Document/Components/SectionTreeview.vue";
import {ref} from "vue";
import axios from "axios";

export default {
    components: {SectionTreeview},
    props: {
        dialog: Boolean,
        parentId: Number,
    },
    setup(props, {emit}) {
        const {loading} = useSharedData();
        const documentStore = useDocumentStore();

        const destinationId = ref(null);

        function move() {
            if (destinationId.value) {
                loading.value = true;
                let url = `/documents/move/${documentStore.fichier.id}/to/${destinationId.value}`;
                axios.put(url).then(response => {
                    documentStore.moveDocument(props.parentId, destinationId.value, response.data);
                    close();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        function close() {
            emit('close')
        }

        return {
            documentStore,
            loading,
            destinationId,
            close,
            move,
        }
    }
}
</script>

<style scoped>

</style>